import Image, { ImageProps } from './Image';

export type { ImageProps };
export default Image;
